"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptDataFromFactoryTransfer = exports.encryptDataForFactoryTransfer = exports.createWavHeader = exports.createAeaHeader = exports.aggressiveSanitizeTitle = exports.sanitizeFullWidthTitle = exports.sanitizeHalfWidthTitle = exports.getHalfWidthTitleLength = exports.getLengthAfterEncodingToSJIS = exports.decodeFromSJIS = exports.encodeToSJIS = exports.sanitizeTrackTitle = exports.halfWidthToFullWidthRange = exports.formatTimeFromFrames = exports.pad = exports.timeToFrames = exports.wordArrayToByteArray = exports.concatArrayBuffers = exports.concatUint8Arrays = exports.uint8arrayToBinaryString = exports.arrayBufferToBinaryString = exports.hexEncode = exports.isBigEndian = exports.dataViewsAreEqual = exports.arrayBuffersAreEqual = exports.stringToCharCodeArray = exports.assertUint8Array = exports.assertString = exports.assertNumber = exports.assertBigInt = exports.assert = exports.withTimeout = exports.sleep = void 0;
/* A bunch of utils. Some might be unused */
var buffer_1 = require("buffer");
var jconv_1 = __importDefault(require("jconv"));
var netmd_interface_1 = require("./netmd-interface");
var crypto_js_1 = __importDefault(require("crypto-js"));
function sleep(msec) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, msec); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sleep = sleep;
function withTimeout(timeoutInMs, cb) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var timer, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timer = setTimeout(function () {
                        reject(new Error("Operation timed out"));
                    }, timeoutInMs);
                    return [4 /*yield*/, cb()];
                case 1:
                    result = _a.sent();
                    clearTimeout(timer);
                    resolve(result);
                    return [2 /*return*/];
            }
        });
    }); });
}
exports.withTimeout = withTimeout;
function assert(condition, message) {
    if (condition) {
        return;
    }
    message = message || 'no message provided';
    throw new Error("Assertion failed: " + message);
}
exports.assert = assert;
function assertBigInt(value, message) {
    if (typeof value === 'bigint') {
        return value;
    }
    throw assert(false, "Expected BigInt type - " + message);
}
exports.assertBigInt = assertBigInt;
function assertNumber(value, message) {
    if (typeof value === 'number') {
        return value;
    }
    throw assert(false, "Expected number type - " + message);
}
exports.assertNumber = assertNumber;
function assertString(value, message) {
    if (typeof value === 'string') {
        return value;
    }
    throw assert(false, "Expected string type - " + message);
}
exports.assertString = assertString;
function assertUint8Array(value, message) {
    if (value instanceof Uint8Array) {
        return value;
    }
    throw assert(false, "Expected Uint8Array type - " + message);
}
exports.assertUint8Array = assertUint8Array;
function stringToCharCodeArray(str) {
    var result = new Array(str.length);
    for (var i = 0; i < str.length; i++) {
        result[i] = str.charCodeAt(i);
    }
    return result;
}
exports.stringToCharCodeArray = stringToCharCodeArray;
// compare ArrayBuffers
function arrayBuffersAreEqual(a, b) {
    return dataViewsAreEqual(new DataView(a), new DataView(b));
}
exports.arrayBuffersAreEqual = arrayBuffersAreEqual;
// compare DataViews
function dataViewsAreEqual(a, b) {
    if (a.byteLength !== b.byteLength)
        return false;
    for (var i = 0; i < a.byteLength; i++) {
        if (a.getUint8(i) !== b.getUint8(i))
            return false;
    }
    return true;
}
exports.dataViewsAreEqual = dataViewsAreEqual;
// Thanks to https://gist.github.com/TooTallNate/4750953
function isBigEndian() {
    return new Uint8Array(new Uint32Array([0x12345678]).buffer)[0] === 0x12;
}
exports.isBigEndian = isBigEndian;
function hexEncode(str) {
    var hex;
    var result = '';
    for (var i = 0; i < str.length; i++) {
        hex = str.charCodeAt(i).toString(16);
        result += ('0' + hex).slice(-2);
    }
    return result;
}
exports.hexEncode = hexEncode;
function arrayBufferToBinaryString(ab) {
    var src = new Uint8Array(ab);
    return uint8arrayToBinaryString(src);
}
exports.arrayBufferToBinaryString = arrayBufferToBinaryString;
function uint8arrayToBinaryString(u8a) {
    var dst = Array(u8a.length);
    u8a.forEach(function (c, i) { return (dst[i] = String.fromCharCode(c)); });
    return dst.join('');
}
exports.uint8arrayToBinaryString = uint8arrayToBinaryString;
function concatUint8Arrays() {
    var e_1, _a, e_2, _b;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var totalLength = 0;
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var a = args_1_1.value;
            totalLength += a.length;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var res = new Uint8Array(totalLength);
    var offset = 0;
    try {
        for (var args_2 = __values(args), args_2_1 = args_2.next(); !args_2_1.done; args_2_1 = args_2.next()) {
            var a = args_2_1.value;
            res.set(a, offset);
            offset += a.length;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (args_2_1 && !args_2_1.done && (_b = args_2.return)) _b.call(args_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return res;
}
exports.concatUint8Arrays = concatUint8Arrays;
function concatArrayBuffers(buffer1, buffer2) {
    var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
}
exports.concatArrayBuffers = concatArrayBuffers;
// Thanks to: https://gist.github.com/artjomb/7ef1ee574a411ba0dd1933c1ef4690d1
function wordToByteArray(word, length, littleEndian) {
    if (littleEndian === void 0) { littleEndian = false; }
    var ba = [], xFF = 0xff;
    var actualLength = length;
    if (littleEndian) {
        length = 4;
    }
    if (length > 0)
        ba.push(word >>> 24);
    if (length > 1)
        ba.push((word >>> 16) & xFF);
    if (length > 2)
        ba.push((word >>> 8) & xFF);
    if (length > 3)
        ba.push(word & xFF);
    if (littleEndian) {
        ba = ba.splice(4 - actualLength).reverse();
    }
    return ba;
}
function wordArrayToByteArray(wordArray, length) {
    if (length === void 0) { length = wordArray.sigBytes; }
    var res = new Uint8Array(length);
    var bytes;
    var i = 0;
    var offset = 0;
    while (length > 0) {
        bytes = wordToByteArray(wordArray.words[i], Math.min(4, length));
        res.set(bytes, offset);
        length -= bytes.length;
        offset += bytes.length;
        i++;
    }
    return res;
}
exports.wordArrayToByteArray = wordArrayToByteArray;
function timeToFrames(time) {
    assert(time.length === 4);
    return ((time[0] * 60 + time[1]) * 60 + time[2]) * 512 + time[3];
}
exports.timeToFrames = timeToFrames;
function pad(str, pad) {
    return (pad + str).slice(-pad.length);
}
exports.pad = pad;
function formatTimeFromFrames(value, frames) {
    if (frames === void 0) { frames = true; }
    var f = value % 512;
    value = (value - f) / 512; // sec
    var s = value % 60;
    value = (value - s) / 60; // min
    var m = value % 60;
    value = (value - m) / 60; // hour
    var h = value;
    return pad(h, '00') + ":" + pad(m, '00') + ":" + pad(s, '00') + (frames ? "+" + pad(f, '000') : "");
}
exports.formatTimeFromFrames = formatTimeFromFrames;
function halfWidthToFullWidthRange(range) {
    var mappings = {
        '0': '０',
        '1': '１',
        '2': '２',
        '3': '３',
        '4': '４',
        '5': '５',
        '6': '６',
        '7': '７',
        '8': '８',
        '9': '９',
        '-': '－',
        '/': '／',
        ';': '；',
    };
    return range
        .split('')
        .map(function (n) { var _a; return (_a = mappings[n]) !== null && _a !== void 0 ? _a : ''; })
        .join('');
}
exports.halfWidthToFullWidthRange = halfWidthToFullWidthRange;
function sanitizeTrackTitle(title) {
    return encodeURIComponent(title);
}
exports.sanitizeTrackTitle = sanitizeTrackTitle;
function encodeToSJIS(utf8String) {
    return jconv_1.default.encode(utf8String, 'SJIS');
}
exports.encodeToSJIS = encodeToSJIS;
function decodeFromSJIS(sjisBuffer) {
    return jconv_1.default.decode(buffer_1.Buffer.from(sjisBuffer), 'SJIS');
}
exports.decodeFromSJIS = decodeFromSJIS;
function getLengthAfterEncodingToSJIS(utf8String) {
    return encodeToSJIS(utf8String).length;
}
exports.getLengthAfterEncodingToSJIS = getLengthAfterEncodingToSJIS;
function getHalfWidthTitleLength(title) {
    // Some characters are written as 2 bytes
    // prettier-ignore
    // '\u309C': -1, '\uFF9F': -1, '\u309B': -1, '\uFF9E': -1 but when they become part of a multi byte character, it will sum up to 0
    var multiByteChars = { "ガ": 1, "ギ": 1, "グ": 1, "ゲ": 1, "ゴ": 1, "ザ": 1, "ジ": 1, "ズ": 1, "ゼ": 1, "ゾ": 1, "ダ": 1, "ヂ": 1, "ヅ": 1, "デ": 1, "ド": 1, "バ": 1, "パ": 1, "ビ": 1, "ピ": 1, "ブ": 1, "プ": 1, "ベ": 1, "ペ": 1, "ボ": 1, "ポ": 1, "ヮ": 1, "ヰ": 1, "ヱ": 1, "ヵ": 1, "ヶ": 1, "ヴ": 1, "ヽ": 1, "ヾ": 1, "が": 1, "ぎ": 1, "ぐ": 1, "げ": 1, "ご": 1, "ざ": 1, "じ": 1, "ず": 1, "ぜ": 1, "ぞ": 1, "だ": 1, "ぢ": 1, "づ": 1, "で": 1, "ど": 1, "ば": 1, "ぱ": 1, "び": 1, "ぴ": 1, "ぶ": 1, "ぷ": 1, "べ": 1, "ぺ": 1, "ぼ": 1, "ぽ": 1, "ゎ": 1, "ゐ": 1, "ゑ": 1, "ゕ": 1, "ゖ": 1, "ゔ": 1, "ゝ": 1, "ゞ": 1 };
    return (title.length +
        title
            .split('')
            .map(function (n) { var _a; return (_a = multiByteChars[n]) !== null && _a !== void 0 ? _a : 0; })
            .reduce(function (a, b) { return a + b; }, 0));
}
exports.getHalfWidthTitleLength = getHalfWidthTitleLength;
function sanitizeHalfWidthTitle(title) {
    var e_3, _a;
    var CharType;
    (function (CharType) {
        CharType[CharType["normal"] = 0] = "normal";
        CharType[CharType["dakuten"] = 1] = "dakuten";
        CharType[CharType["handakuten"] = 2] = "handakuten";
    })(CharType || (CharType = {}));
    var handakutenPossible = 'はひふへほハヒフヘホ'.split('');
    var dakutenPossible = 'かきくけこさしすせそたちつてとカキクケコサシスセソタチツテト'.split('').concat(handakutenPossible);
    //'Flatten' all the characters followed by the (han)dakuten character into one
    var dakutenFix = [];
    var type = CharType.normal;
    try {
        for (var _b = __values(sanitizeFullWidthTitle(title, true)
            .split('')
            .reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var char = _c.value;
            //This only works for full-width kana. It will get converted to half-width later anyway...
            switch (type) {
                case CharType.dakuten:
                    if (dakutenPossible.includes(char)) {
                        dakutenFix.push(String.fromCharCode(char.charCodeAt(0) + 1));
                        type = CharType.normal;
                        break;
                    } //Else fall through
                case CharType.handakuten:
                    if (handakutenPossible.includes(char)) {
                        dakutenFix.push(String.fromCharCode(char.charCodeAt(0) + 2));
                        type = CharType.normal;
                        break;
                    } //Else fall through
                case CharType.normal:
                    switch (char) {
                        case '\u309B':
                        case '\u3099':
                        case '\uFF9E':
                            type = CharType.dakuten;
                            break;
                        case '\u309C':
                        case '\u309A':
                        case '\uFF9F':
                            type = CharType.handakuten;
                            break;
                        default:
                            type = CharType.normal;
                            dakutenFix.push(char);
                            break;
                    }
                    break;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    title = dakutenFix.reverse().join('');
    // prettier-ignore
    var mappings = { '－': '-', 'ｰ': '-', 'ァ': 'ｧ', 'ア': 'ｱ', 'ィ': 'ｨ', 'イ': 'ｲ', 'ゥ': 'ｩ', 'ウ': 'ｳ', 'ェ': 'ｪ', 'エ': 'ｴ', 'ォ': 'ｫ', 'オ': 'ｵ', 'カ': 'ｶ', 'ガ': 'ｶﾞ', 'キ': 'ｷ', 'ギ': 'ｷﾞ', 'ク': 'ｸ', 'グ': 'ｸﾞ', 'ケ': 'ｹ', 'ゲ': 'ｹﾞ', 'コ': 'ｺ', 'ゴ': 'ｺﾞ', 'サ': 'ｻ', 'ザ': 'ｻﾞ', 'シ': 'ｼ', 'ジ': 'ｼﾞ', 'ス': 'ｽ', 'ズ': 'ｽﾞ', 'セ': 'ｾ', 'ゼ': 'ｾﾞ', 'ソ': 'ｿ', 'ゾ': 'ｿﾞ', 'タ': 'ﾀ', 'ダ': 'ﾀﾞ', 'チ': 'ﾁ', 'ヂ': 'ﾁﾞ', 'ッ': 'ｯ', 'ツ': 'ﾂ', 'ヅ': 'ﾂﾞ', 'テ': 'ﾃ', 'デ': 'ﾃﾞ', 'ト': 'ﾄ', 'ド': 'ﾄﾞ', 'ナ': 'ﾅ', 'ニ': 'ﾆ', 'ヌ': 'ﾇ', 'ネ': 'ﾈ', 'ノ': 'ﾉ', 'ハ': 'ﾊ', 'バ': 'ﾊﾞ', 'パ': 'ﾊﾟ', 'ヒ': 'ﾋ', 'ビ': 'ﾋﾞ', 'ピ': 'ﾋﾟ', 'フ': 'ﾌ', 'ブ': 'ﾌﾞ', 'プ': 'ﾌﾟ', 'ヘ': 'ﾍ', 'ベ': 'ﾍﾞ', 'ペ': 'ﾍﾟ', 'ホ': 'ﾎ', 'ボ': 'ﾎﾞ', 'ポ': 'ﾎﾟ', 'マ': 'ﾏ', 'ミ': 'ﾐ', 'ム': 'ﾑ', 'メ': 'ﾒ', 'モ': 'ﾓ', 'ャ': 'ｬ', 'ヤ': 'ﾔ', 'ュ': 'ｭ', 'ユ': 'ﾕ', 'ョ': 'ｮ', 'ヨ': 'ﾖ', 'ラ': 'ﾗ', 'リ': 'ﾘ', 'ル': 'ﾙ', 'レ': 'ﾚ', 'ロ': 'ﾛ', 'ワ': 'ﾜ', 'ヲ': 'ｦ', 'ン': 'ﾝ', 'ー': '-', 'ヮ': 'ヮ', 'ヰ': 'ヰ', 'ヱ': 'ヱ', 'ヵ': 'ヵ', 'ヶ': 'ヶ', 'ヴ': 'ｳﾞ', 'ヽ': 'ヽ', 'ヾ': 'ヾ', '・': '･', '「': '｢', '」': '｣', '。': '｡', '、': '､', '！': '!', '＂': '"', '＃': '#', '＄': '$', '％': '%', '＆': '&', '＇': "'", '（': '(', '）': ')', '＊': '*', '＋': '+', '，': ',', '．': '.', '／': '/', '：': ':', '；': ';', '＜': '<', '＝': '=', '＞': '>', '？': '?', '＠': '@', 'Ａ': 'A', 'Ｂ': 'B', 'Ｃ': 'C', 'Ｄ': 'D', 'Ｅ': 'E', 'Ｆ': 'F', 'Ｇ': 'G', 'Ｈ': 'H', 'Ｉ': 'I', 'Ｊ': 'J', 'Ｋ': 'K', 'Ｌ': 'L', 'Ｍ': 'M', 'Ｎ': 'N', 'Ｏ': 'O', 'Ｐ': 'P', 'Ｑ': 'Q', 'Ｒ': 'R', 'Ｓ': 'S', 'Ｔ': 'T', 'Ｕ': 'U', 'Ｖ': 'V', 'Ｗ': 'W', 'Ｘ': 'X', 'Ｙ': 'Y', 'Ｚ': 'Z', '［': '[', '＼': '\\', '］': ']', '＾': '^', '＿': '_', '｀': '`', 'ａ': 'a', 'ｂ': 'b', 'ｃ': 'c', 'ｄ': 'd', 'ｅ': 'e', 'ｆ': 'f', 'ｇ': 'g', 'ｈ': 'h', 'ｉ': 'i', 'ｊ': 'j', 'ｋ': 'k', 'ｌ': 'l', 'ｍ': 'm', 'ｎ': 'n', 'ｏ': 'o', 'ｐ': 'p', 'ｑ': 'q', 'ｒ': 'r', 'ｓ': 's', 'ｔ': 't', 'ｕ': 'u', 'ｖ': 'v', 'ｗ': 'w', 'ｘ': 'x', 'ｙ': 'y', 'ｚ': 'z', '｛': '{', '｜': '|', '｝': '}', '～': '~', '\u3000': ' ', '０': '0', '１': '1', '２': '2', '３': '3', '４': '4', '５': '5', '６': '6', '７': '7', '８': '8', '９': '9', 'ぁ': 'ｧ', 'あ': 'ｱ', 'ぃ': 'ｨ', 'い': 'ｲ', 'ぅ': 'ｩ', 'う': 'ｳ', 'ぇ': 'ｪ', 'え': 'ｴ', 'ぉ': 'ｫ', 'お': 'ｵ', 'か': 'ｶ', 'が': 'ｶﾞ', 'き': 'ｷ', 'ぎ': 'ｷﾞ', 'く': 'ｸ', 'ぐ': 'ｸﾞ', 'け': 'ｹ', 'げ': 'ｹﾞ', 'こ': 'ｺ', 'ご': 'ｺﾞ', 'さ': 'ｻ', 'ざ': 'ｻﾞ', 'し': 'ｼ', 'じ': 'ｼﾞ', 'す': 'ｽ', 'ず': 'ｽﾞ', 'せ': 'ｾ', 'ぜ': 'ｾﾞ', 'そ': 'ｿ', 'ぞ': 'ｿﾞ', 'た': 'ﾀ', 'だ': 'ﾀﾞ', 'ち': 'ﾁ', 'ぢ': 'ﾁﾞ', 'っ': 'ｯ', 'つ': 'ﾂ', 'づ': 'ﾂﾞ', 'て': 'ﾃ', 'で': 'ﾃﾞ', 'と': 'ﾄ', 'ど': 'ﾄﾞ', 'な': 'ﾅ', 'に': 'ﾆ', 'ぬ': 'ﾇ', 'ね': 'ﾈ', 'の': 'ﾉ', 'は': 'ﾊ', 'ば': 'ﾊﾞ', 'ぱ': 'ﾊﾟ', 'ひ': 'ﾋ', 'び': 'ﾋﾞ', 'ぴ': 'ﾋﾟ', 'ふ': 'ﾌ', 'ぶ': 'ﾌﾞ', 'ぷ': 'ﾌﾟ', 'へ': 'ﾍ', 'べ': 'ﾍﾞ', 'ぺ': 'ﾍﾟ', 'ほ': 'ﾎ', 'ぼ': 'ﾎﾞ', 'ぽ': 'ﾎﾟ', 'ま': 'ﾏ', 'み': 'ﾐ', 'む': 'ﾑ', 'め': 'ﾒ', 'も': 'ﾓ', 'ゃ': 'ｬ', 'や': 'ﾔ', 'ゅ': 'ｭ', 'ゆ': 'ﾕ', 'ょ': 'ｮ', 'よ': 'ﾖ', 'ら': 'ﾗ', 'り': 'ﾘ', 'る': 'ﾙ', 'れ': 'ﾚ', 'ろ': 'ﾛ', 'わ': 'ﾜ', 'を': 'ｦ', 'ん': 'ﾝ', 'ゎ': 'ヮ', 'ゐ': 'ヰ', 'ゑ': 'ヱ', 'ゕ': 'ヵ', 'ゖ': 'ヶ', 'ゔ': 'ｳﾞ', 'ゝ': 'ヽ', 'ゞ': 'ヾ' };
    var allowedHalfWidthKana = Object.values(mappings);
    function check(n) {
        if (mappings[n])
            return mappings[n];
        if (n.charCodeAt(0) < 0x7f || allowedHalfWidthKana.includes(n))
            return n;
        return null;
    }
    var newTitle = title
        .split('')
        .map(function (c) {
        var _a, _b;
        return (_b = (_a = check(c)) !== null && _a !== void 0 ? _a : check(c.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) !== null && _b !== void 0 ? _b : ' ';
    })
        .join('');
    // Check if the amount of characters is the same as the amount of encoded bytes (when accounting for dakuten). Otherwise the disc might end up corrupted
    var sjisEncoded = jconv_1.default.encode(newTitle, 'SJIS');
    if (sjisEncoded.length !== getHalfWidthTitleLength(title))
        return aggressiveSanitizeTitle(title); //Fallback
    return newTitle;
}
exports.sanitizeHalfWidthTitle = sanitizeHalfWidthTitle;
function sanitizeFullWidthTitle(title, justRemap) {
    if (justRemap === void 0) { justRemap = false; }
    // prettier-ignore
    var mappings = { '!': '！', '"': '＂', '#': '＃', '$': '＄', '%': '％', '&': '＆', "'": '＇', '(': '（', ')': '）', '*': '＊', '+': '＋', ',': '，', '-': '－', '.': '．', '/': '／', ':': '：', ';': '；', '<': '＜', '=': '＝', '>': '＞', '?': '？', '@': '＠', 'A': 'Ａ', 'B': 'Ｂ', 'C': 'Ｃ', 'D': 'Ｄ', 'E': 'Ｅ', 'F': 'Ｆ', 'G': 'Ｇ', 'H': 'Ｈ', 'I': 'Ｉ', 'J': 'Ｊ', 'K': 'Ｋ', 'L': 'Ｌ', 'M': 'Ｍ', 'N': 'Ｎ', 'O': 'Ｏ', 'P': 'Ｐ', 'Q': 'Ｑ', 'R': 'Ｒ', 'S': 'Ｓ', 'T': 'Ｔ', 'U': 'Ｕ', 'V': 'Ｖ', 'W': 'Ｗ', 'X': 'Ｘ', 'Y': 'Ｙ', 'Z': 'Ｚ', '[': '［', '\\': '＼', ']': '］', '^': '＾', '_': '＿', '`': '｀', 'a': 'ａ', 'b': 'ｂ', 'c': 'ｃ', 'd': 'ｄ', 'e': 'ｅ', 'f': 'ｆ', 'g': 'ｇ', 'h': 'ｈ', 'i': 'ｉ', 'j': 'ｊ', 'k': 'ｋ', 'l': 'ｌ', 'm': 'ｍ', 'n': 'ｎ', 'o': 'ｏ', 'p': 'ｐ', 'q': 'ｑ', 'r': 'ｒ', 's': 'ｓ', 't': 'ｔ', 'u': 'ｕ', 'v': 'ｖ', 'w': 'ｗ', 'x': 'ｘ', 'y': 'ｙ', 'z': 'ｚ', '{': '｛', '|': '｜', '}': '｝', '~': '～', ' ': '\u3000', '0': '０', '1': '１', '2': '２', '3': '３', '4': '４', '5': '５', '6': '６', '7': '７', '8': '８', '9': '９', 'ｧ': 'ァ', 'ｱ': 'ア', 'ｨ': 'ィ', 'ｲ': 'イ', 'ｩ': 'ゥ', 'ｳ': 'ウ', 'ｪ': 'ェ', 'ｴ': 'エ', 'ｫ': 'ォ', 'ｵ': 'オ', 'ｶ': 'カ', 'ｶﾞ': 'ガ', 'ｷ': 'キ', 'ｷﾞ': 'ギ', 'ｸ': 'ク', 'ｸﾞ': 'グ', 'ｹ': 'ケ', 'ｹﾞ': 'ゲ', 'ｺ': 'コ', 'ｺﾞ': 'ゴ', 'ｻ': 'サ', 'ｻﾞ': 'ザ', 'ｼ': 'シ', 'ｼﾞ': 'ジ', 'ｽ': 'ス', 'ｽﾞ': 'ズ', 'ｾ': 'セ', 'ｾﾞ': 'ゼ', 'ｿ': 'ソ', 'ｿﾞ': 'ゾ', 'ﾀ': 'タ', 'ﾀﾞ': 'ダ', 'ﾁ': 'チ', 'ﾁﾞ': 'ヂ', 'ｯ': 'ッ', 'ﾂ': 'ツ', 'ﾂﾞ': 'ヅ', 'ﾃ': 'テ', 'ﾃﾞ': 'デ', 'ﾄ': 'ト', 'ﾄﾞ': 'ド', 'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ', 'ﾊ': 'ハ', 'ﾊﾞ': 'バ', 'ﾊﾟ': 'パ', 'ﾋ': 'ヒ', 'ﾋﾞ': 'ビ', 'ﾋﾟ': 'ピ', 'ﾌ': 'フ', 'ﾌﾞ': 'ブ', 'ﾌﾟ': 'プ', 'ﾍ': 'ヘ', 'ﾍﾞ': 'ベ', 'ﾍﾟ': 'ペ', 'ﾎ': 'ホ', 'ﾎﾞ': 'ボ', 'ﾎﾟ': 'ポ', 'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ', 'ｬ': 'ャ', 'ﾔ': 'ヤ', 'ｭ': 'ュ', 'ﾕ': 'ユ', 'ｮ': 'ョ', 'ﾖ': 'ヨ', 'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ', 'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン', 'ｰ': 'ー', 'ヮ': 'ヮ', 'ヰ': 'ヰ', 'ヱ': 'ヱ', 'ヵ': 'ヵ', 'ヶ': 'ヶ', 'ｳﾞ': 'ヴ', 'ヽ': 'ヽ', 'ヾ': 'ヾ', '･': '・', '｢': '「', '｣': '」', '｡': '。', '､': '、' };
    var newTitle = title
        .split('')
        .map(function (n) { var _a; return (_a = mappings[n]) !== null && _a !== void 0 ? _a : n; })
        .join('');
    if (justRemap)
        return newTitle;
    var sjisEncoded = jconv_1.default.encode(newTitle, 'SJIS');
    if (jconv_1.default.decode(sjisEncoded, 'SJIS') !== newTitle)
        return aggressiveSanitizeTitle(title); // Fallback
    if (sjisEncoded.length !== title.length * 2)
        return aggressiveSanitizeTitle(title); // Fallback (every character in the full-width title is 2 bytes)
    return newTitle;
}
exports.sanitizeFullWidthTitle = sanitizeFullWidthTitle;
function aggressiveSanitizeTitle(title) {
    return title.normalize('NFD').replace(/[^\x00-\x7F]/g, '');
}
exports.aggressiveSanitizeTitle = aggressiveSanitizeTitle;
function createAeaHeader(name, channels, soundgroups, groupstart, encrypted, flags) {
    if (name === void 0) { name = ''; }
    if (channels === void 0) { channels = 2; }
    if (soundgroups === void 0) { soundgroups = 1; }
    if (groupstart === void 0) { groupstart = 0; }
    if (encrypted === void 0) { encrypted = 0; }
    if (flags === void 0) { flags = [0, 0, 0, 0, 0, 0, 0, 0]; }
    var encodedName = buffer_1.Buffer.from(name);
    var header = concatUint8Arrays(new Uint8Array(wordToByteArray(2048, 4, true)), encodedName, new Uint8Array(256 - encodedName.length), new Uint8Array(wordToByteArray(soundgroups, 4, true)), new Uint8Array([channels, 0]), new Uint8Array(wordToByteArray(flags[0], 4, true)), new Uint8Array(wordToByteArray(flags[1], 4, true)), new Uint8Array(wordToByteArray(flags[2], 4, true)), new Uint8Array(wordToByteArray(flags[3], 4, true)), new Uint8Array(wordToByteArray(flags[4], 4, true)), new Uint8Array(wordToByteArray(flags[5], 4, true)), new Uint8Array(wordToByteArray(flags[6], 4, true)), new Uint8Array(wordToByteArray(flags[7], 4, true)), new Uint8Array(wordToByteArray(0, 4, true)), new Uint8Array(wordToByteArray(encrypted, 4, true)), new Uint8Array(wordToByteArray(groupstart, 4, true)));
    return concatUint8Arrays(header, new Uint8Array(2048 - header.length));
}
exports.createAeaHeader = createAeaHeader;
function createWavHeader(format, bytes) {
    var jointStereo, bytesPerFrame;
    switch (format) {
        case netmd_interface_1.DiscFormat.lp2:
            bytesPerFrame = 192;
            jointStereo = 0;
            break;
        case netmd_interface_1.DiscFormat.lp4:
            bytesPerFrame = 96;
            jointStereo = 1;
            break;
        default:
            throw new Error("Cannot create WAV header for disc type " + netmd_interface_1.DiscFormat[format]);
    }
    var bytesPerSecond = (bytesPerFrame * 44100) / 512;
    return concatUint8Arrays(buffer_1.Buffer.from('RIFF'), new Uint8Array(wordToByteArray(bytes + 60, 4, true)), buffer_1.Buffer.from('WAVEfmt '), new Uint8Array(wordToByteArray(32, 4, true)), new Uint8Array(wordToByteArray(0x270, 2, true)), // ATRAC3
    new Uint8Array(wordToByteArray(2, 2, true)), // Stereo
    new Uint8Array(wordToByteArray(44100, 4, true)), new Uint8Array(wordToByteArray(bytesPerSecond, 4, true)), new Uint8Array(wordToByteArray(bytesPerFrame * 2, 2, true)), new Uint8Array([0, 0]), new Uint8Array(wordToByteArray(14, 2, true)), new Uint8Array(wordToByteArray(1, 2, true)), new Uint8Array(wordToByteArray(bytesPerFrame, 4, true)), new Uint8Array(wordToByteArray(jointStereo, 2, true)), new Uint8Array(wordToByteArray(jointStereo, 2, true)), new Uint8Array(wordToByteArray(1, 2, true)), new Uint8Array(wordToByteArray(0, 2, true)), buffer_1.Buffer.from('data'), new Uint8Array(wordToByteArray(bytes, 4, true)));
}
exports.createWavHeader = createWavHeader;
function encryptDataForFactoryTransfer(plaintext) {
    var factoryKey = new Uint8Array([0x00, 0x11, 0x22, 0x33, 0x44, 0x55, 0x66, 0x77]);
    var iv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
    var dataWA = crypto_js_1.default.lib.WordArray.create(plaintext);
    var keyWA = crypto_js_1.default.lib.WordArray.create(factoryKey);
    var ivWA = crypto_js_1.default.lib.WordArray.create(iv);
    var ciphertext = crypto_js_1.default.DES.encrypt(dataWA, keyWA, { mode: crypto_js_1.default.mode.ECB, iv: ivWA });
    var ciphertextArray = wordArrayToByteArray(ciphertext.ciphertext);
    return ciphertextArray.subarray(0, ciphertextArray.length - 8);
}
exports.encryptDataForFactoryTransfer = encryptDataForFactoryTransfer;
function decryptDataFromFactoryTransfer(ciphertext) {
    var factoryKey = new Uint8Array([0x00, 0x11, 0x22, 0x33, 0x44, 0x55, 0x66, 0x77]);
    var iv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
    var ciphertextWA = crypto_js_1.default.lib.WordArray.create(ciphertext);
    var keyWA = crypto_js_1.default.lib.WordArray.create(factoryKey);
    var ivWA = crypto_js_1.default.lib.WordArray.create(iv);
    var plaintext = crypto_js_1.default.DES.decrypt({ ciphertext: ciphertextWA }, keyWA, { mode: crypto_js_1.default.mode.ECB, iv: ivWA });
    plaintext.sigBytes = ciphertext.length;
    return wordArrayToByteArray(plaintext);
}
exports.decryptDataFromFactoryTransfer = decryptDataFromFactoryTransfer;
//# sourceMappingURL=utils.js.map